import { render, staticRenderFns } from "./paymentIframe.vue?vue&type=template&id=214b568f&scoped=true"
import script from "./paymentIframe.vue?vue&type=script&lang=js"
export * from "./paymentIframe.vue?vue&type=script&lang=js"
import style0 from "./paymentIframe.vue?vue&type=style&index=0&id=214b568f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214b568f",
  null
  
)

export default component.exports